import { OccupantDetail, LegacySalesSubmissionFrequency } from '@centecomm/portal-service';
import { Occupant } from '../../State/Occupants/Types/Occupant';

// TODO: Should these be consolidated in some way
type OccupantToMap = OccupantDetail;

const mapOccupantResponseToOccupant = ({
    id,
    marketingName,
    spaces,
    phone,
    leaseStart,
    leaseEnd,
    collectSalesStartDate,
    propertyId,
    propertyName,
    salesSubmissionFrequency,
}: OccupantToMap): Occupant => ({
    name: marketingName,
    id,
    propertyId,
    propertyName,
    collectSalesStartDate,
    phone,
    canEdit: true, // TODO: this needs set properly and from the right API.
    spaces,
    leaseStart,
    leaseEnd,
    salesSubmissionFrequency: salesSubmissionFrequency as LegacySalesSubmissionFrequency,
    shouldSubmitSales: salesSubmissionFrequency !== LegacySalesSubmissionFrequency.notRequired,
});

export default mapOccupantResponseToOccupant;
